import { calculateRatio, isValidNumber } from "./shared";

export const ikedaValidator = (getFieldValue) => ({
  validator(_, value) {
    const pulp = getFieldValue("cpcl");
    const crown = getFieldValue("cl");

    if (!value) return Promise.reject(new Error("This field is required"));
    if (!isValidNumber(value))
      return Promise.reject(new Error("Only numbers and '.' allowed"));
    if (!pulp || !crown) return Promise.resolve();

    if (parseFloat(pulp) >= parseFloat(crown)) {
      return Promise.reject(
        new Error("Crown length must be greater than pulp length")
      );
    }

    const ratio = calculateRatio(pulp, crown);
    if (ratio <= 0.001 || ratio >= 0.375) {
      return Promise.reject(
        new Error("Pulp-to-Crown ratio must be between 0.001 and 0.375")
      );
    }

    return Promise.resolve();
  },
});
